//
export const AUTH_INVALIDATE = 'auth/AUTH_INVALIDATE';

//login
export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST';
export const LOGIN_REQUEST_TOKEN = 'auth/LOGIN_REQUEST_TOKEN';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'auth/LOGIN_FAILURE';

//logout
export const LOGOUT_REQUEST = 'auth/LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'auth/LOGOUT_FAILURE';

// url after succesfull login
export const URL_AFTER_LOGIN = 'auth/URL_AFTER_LOGIN';



// WEBPACK FOOTER //
// ./src/modules/auth/auth.actionTypes.js